import VinWonderTicketList from './VinWonderTicketList';

export default VinWonderTicketList;
